import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../services/apiService";

export const fetchRemit = createAsyncThunk(
  "remit/fetchRemit",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.get("/admin/remits", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const approveRemit = createAsyncThunk(
  "remit/approveRemit",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.post(`/approve/remit/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data; //
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const remitSlice = createSlice({
  name: "remit",
  initialState: {
    remits: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRemit.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchRemit.fulfilled, (state, action) => {
        state.status = "success";
        state.remits = action.payload.data;
      })
      .addCase(fetchRemit.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(approveRemit.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(approveRemit.fulfilled, (state) => {
        state.status = "idle";
        state.error = null;
      })
      .addCase(approveRemit.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.payload;
      });
  },
});

export default remitSlice.reducer;
